import { useState, useEffect } from "react"

import Grid from '@material-ui/core/Grid'

import Table from '@base/Table'
import {
	verifyPagingAndSorting,
	PAGE,
	SIZE,
	ASC,
	TOTAL_ELEMENTS,
	TOTAL_PAGES,
} from '@base/Table/Utils'

import EscolaService from "@services/EscolaService";

import { removePagingAndSorting } from '@helpers/PaginationHelper';

export const PacotesRecebidosTableView = (props) => {
	const processo = props.processo;
	const escola = props.escola;

	const [loading, setLoading] = useState(true);
	const [objetosPostais, setObjetosPostais] = useState([]);

	const [page, setPage] = useState(PAGE);
	const [size, setSize] = useState(SIZE);
	const [defaultOrderBy,] = useState('dataRecebimento');
	const [sort, setSort] = useState([ {orderBy: defaultOrderBy, order: ASC} ])
	const [totalElements, setTotalElements] = useState(TOTAL_ELEMENTS);
	const [totalPages, setTotalPages] = useState(TOTAL_PAGES);


	const columnsObjsPostais = [
		{ label: 'Protocolo', name: 'protocolo', func: null, key: true },
		{ label: 'Origem', name: 'origem', func: null, key: false },
		{ label: 'Data de Postagem', name: 'dataPostagem', func: null, key: false },
		{ label: 'Data de Recebimento', name: 'dataRecebimento', func: null, key: false },
		{ label: 'Responsável pela Triagem', name: 'responsavelTriagem', func: null, key: false },
		{ label: 'Peso', name: 'peso', func: null, key: false },
		{ label: 'Código Postal', name: 'codigoPostal', func: null, key: false },
		{ label: 'Caixa', name: 'caixaCodigo', func: null, key: false, ordering: false },
		{ label: 'Posição', name: 'posicaoNaCaixa', func: null, key: false, ordering: false }
	];

	useEffect(() => {

		const f = verifyPagingAndSorting(removePagingAndSorting(props.filtros), page, size, sort);

		if (escola !== undefined && escola.codigoInep !== undefined) {

			EscolaService.getObjetosPostaisPorEscola(processo, escola.codigoInep, f).then(resposta => {

				if (resposta.status === 204) {

					setObjetosPostais([]);

				} else {

					let { content, number, size, totalElements, totalPages } = resposta.data;

					setObjetosPostais(content);
					setPage(number);
					setSize(size);
					setTotalElements(totalElements);
					setTotalPages(totalPages);

				}

			}).catch(error => alert("error", "Ocorreu um problema ao buscar as pendências da escola."));

		}

		setLoading(false);
		
	}, [escola, processo, page, size, sort, props.filtros]);

	const handlePage = page => setPage(page);
	const handleRowsPerPage = (size, page) => { setPage(page); setSize(size); };
	const verifyOrderBy = (orderBy) => orderBy === 'protocolo' ? "id" : orderBy;
	const handleSort = (orderBy, order) => {
		if (sort.find(s => s.orderBy === verifyOrderBy(orderBy))) {
			let newSort = sort.filter(s => s.orderBy !== verifyOrderBy(orderBy));
			newSort.splice(sort.indexOf(sort.find(s => s.orderBy === verifyOrderBy(orderBy))), 0, {orderBy: verifyOrderBy(orderBy), order: order})
			setSort([...newSort]);
		} else {
			setSort([...sort.filter(s => s.orderBy !== verifyOrderBy(orderBy)), {orderBy: verifyOrderBy(orderBy), order: order} ]);
		}
	}
	const handleClearSort = (orderBy) => orderBy ? setSort([...sort.filter(s => s.orderBy !== verifyOrderBy(orderBy)) ]) : setSort([ {orderBy: defaultOrderBy, order: ASC} ]);
	const handleTotalPages = () => totalPages;
	const handleTotalElements = () => totalElements;

	return (
		<>
			<br />
			<Grid container spacing={5}>
				<Grid item xs={12}>
					<Table
						style={{ marginTop: 0 }}
						columns={columnsObjsPostais}
						tableData={objetosPostais}
						actions={[]}
						page={page}
						handlePage={handlePage}
						handleTotalPages={handleTotalPages}
						handleTotalElements={handleTotalElements}
						rowsPerPage={size}
						handleRowsPerPage={handleRowsPerPage}
						sort={sort}
						handleSort={handleSort}
						handleClearSort={handleClearSort}
						loading={loading}
					/>
				</Grid>
			</Grid>

		</>
	);
}

export default PacotesRecebidosTableView;
